import { type FC, useState } from 'react';
import { difference } from 'lodash-es';

import { type MCQuestion } from '@editor2/types/pageElements';
import ChildrenChangesWrapper from '../common/ChildrenChangesWrapper';
import ExpandChangesButton from '../common/ExpandChangesButton';
import ChangesDiff from '../common/ChangesDiff';
import DeletedItem from '../common/DeletedItem';
import { getChoiceTitle } from '../helpers';
import { elementHeader } from '../styles';

interface Props {
	initialElement: MCQuestion;
	currentElement: MCQuestion;
	choices: any;
}

const ChoicesDiff: FC<Props> = (props) => {
	const { initialElement, currentElement, choices } = props;

	const [showChildren, setShowChildren] = useState(true);

	return (
		<>
			{choices && !showChildren && <ExpandChangesButton onClick={() => setShowChildren(true)} />}

			{showChildren && (
				<ChildrenChangesWrapper setShowChildren={setShowChildren}>
					{choices &&
						choices.map((choice, i) => {
							const { id, ...changes } = choice;

							const initialIndex = initialElement?.choices.findIndex(
								(el) => el.family_id === currentElement.choices[i].family_id
							);
							const initialChoice = initialElement?.choices[initialIndex];

							if (Object.keys(changes).length === 0 && i === initialIndex) return;

							return (
								<ChangesDiff
									key={i}
									index={i}
									initialIndex={initialIndex}
									initial={initialChoice}
									attributeChanges={changes}
									title={`Choice ${i + 1}`}
									styles={elementHeader}
								/>
							);
						})}

					{choices &&
						difference(
							initialElement?.choices.map((el) => el.family_id) || [],
							currentElement.choices.map((el) => el.family_id)
						).map((family_id) => {
							return (
								<DeletedItem
									key={family_id}
									title={getChoiceTitle(
										initialElement?.choices.find((el) => el.family_id === family_id)
									)}
									styles={elementHeader}
								/>
							);
						})}
				</ChildrenChangesWrapper>
			)}
		</>
	);
};

export default ChoicesDiff;
